import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import { Content } from './Content';


export const Container = ({
  relationshipLink,
}) => {
  const {
    isInitializing, loadingError, collection,
  } = useLink(relationshipLink);

  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
      }}
    />
  );
};

Container.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
};

export default Container;
